/**
 * Global Directive Dependencies
 */
import Sortable from './sortable'
import Clipboard from './clipboard'

/**
 * Global Directives Object
 *
 * @type {Object}
 */
const directives = {
    sortable: Sortable,
    clipboard: Clipboard
}

export default directives



// WEBPACK FOOTER //
// ./src/directives/index.js